import React from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';
import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';

import {
  I18nProvider,
  EntityMapperContext,
} from '@uncinc/react-drupal-core';
import {
  KitchenSinkComponentMapperContext,
} from '@uncinc/uncinc-react-kitchen-sink';


import blocksMapper from '../../mappers/blocks';
import DesignSystem from '../DesignSystem';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import profileMapper from '../../mappers/profile';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import i18next from '../../config/i18next';
import Entity from '../Entity';
import CustomRoute from '../CustomRoute';
import Search from '../Search';
import MapSearch from '../MapSearch';
import HeaderMenu from '../../implementations/Menu/HeaderMenu';
import FooterMenu from '../../implementations/Menu/FooterMenu';

import { ButtonWrapper } from '../../components';

import './style.scss';

const entityTypeMapper = {
  block: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  profile: profileMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

const kitchenSinkComponentMapper = {
  Button: ButtonWrapper,
};


const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  }, 'route-' + path.toLowerCase().replace('/', '-').replace(' ', '_'));

  return (
    <EntityMapperContext.Provider value={entityTypeMapper}>
      <I18nProvider locale={language} i18next={i18next}>
        <KitchenSinkComponentMapperContext.Provider value={kitchenSinkComponentMapper}>
          <div className={classes} language={language}>
            <header>
              <HeaderMenu />
            </header>
            <main className="main">
              <Switch>
                {/* Add routes here */}
                <CustomRoute path={['/zoeken', '/search']} render={() => (<Search />)} />
                <CustomRoute path="/map" render={() => (<MapSearch />)} />
                <CustomRoute path={['/design-system', '/nl/design-system', '/en/design-system']} render={() => (<DesignSystem />)} />
                <Route render={() => (<Entity />)} />
              </Switch>
            </main>
            <footer>
              <FooterMenu />
            </footer>
            <div id="modal-root" />
          </div>
        </KitchenSinkComponentMapperContext.Provider>
      </I18nProvider>
    </EntityMapperContext.Provider>
  );
};

export default App;
